const fr = {
  nav: {
    about: "À propos",
    about_diego: "À propos de Diego",
    trips: "Mes voyages",
    plan: "Planifier",
    new_trip: "Planifier un voyage",
    login: "Se connecter",
    register: "Commencer",
    account: "Mon compte",
    logout: "Déconnexion",
    admin: "Admin",
    install: "Installer",
  },
  pwa: {
    install: "Installer",
    ios_title: "Installer Voyage-r",
    ios_step1_pre: "Appuyez sur l'icône",
    ios_step1_btn: "Partager",
    ios_step1_post: "en bas de Safari",
    ios_step2_pre: "Faites défiler et appuyez sur",
    ios_step2_btn: "Sur l'écran d'accueil",
    ios_step3_pre: "Confirmez en appuyant sur",
    ios_step3_btn: "Ajouter",
  },
  landing: {
    about: "À propos",
    my_trips: "Mes voyages",
    login: "Se connecter",
    start: "Commencer",
    hero_label: "Planification de voyages sur mesure",
    hero_title1: "Partez l'esprit léger.",
    hero_title2: "Je m'occupe de tout.",
    hero_desc: "Décrivez votre voyage en 5 minutes. Je conçois votre itinéraire sur mesure, jour par jour. Et je valide chaque détail personnellement avant de vous le livrer.",
    hero_cta: "Planifier mon voyage",
    hero_secondary: "Qui est Diego ?",
    hero_note: "Gratuit pour démarrer · À partir de 29 € pour débloquer votre itinéraire validé",
    hero_photo: "Chaque voyage a sa propre histoire",
    hero_price: "Dès 29 €",
    hero_price_sub: "paiement unique",
    features_label: "Pourquoi Voyage-r ?",
    features_title: "Une agence de voyage,",
    features_title_em: "dans votre poche",
    feat1_title: "Un itinéraire taillé sur mesure",
    feat1_desc: "Votre conseiller expert analyse vos envies, votre budget et votre rythme pour concevoir un voyage unique — pas un copié-collé de guide touristique.",
    feat2_title: "Validé par un vrai passionné",
    feat2_desc: "Diego, expert en Afrique, Océan Indien et Europe authentique, révise personnellement chaque itinéraire avant que vous y accédiez.",
    feat3_title: "Tout, vraiment tout inclus",
    feat3_desc: "Budget détaillé, infos pratiques, météo par mois, convertisseur de devises, liens de réservation pré-remplis.",
    feat4_title: "Votre conseiller voyage privé",
    feat4_desc: "Avec l'offre Sérénité, un conseiller dédié connaît votre itinéraire sur le bout des doigts — posez-lui n'importe quelle question, à toute heure.",
    steps_label: "Le processus",
    steps_title: "Quatre étapes vers l'aventure",
    step1_title: "Décrivez votre voyage",
    step1_desc: "Remplissez un formulaire en 5 minutes : destination, dates, envies profondes et budget total.",
    step2_title: "Votre dossier prend forme",
    step2_desc: "Votre conseiller expert compose un itinéraire jour par jour, riche, précis et enthousiaste.",
    step3_title: "Diego valide et peaufine",
    step3_desc: "Votre expert humain passe en revue chaque détail et donne son aval avant livraison.",
    step4_title: "Votre voyage, débloqué",
    step4_desc: "Choisissez l'offre qui vous correspond — et partez l'esprit léger. On s'occupe de tout.",
    plans_label: "Nos offres",
    plans_title: "Choisissez votre niveau d'accompagnement",
    plans_subtitle: "Paiement unique par voyage · Accès permanent pendant toute la durée du voyage + 15 jours",
    per_trip: "par voyage",
    popular: "Le plus populaire",
    plan_cta: "Choisir cette offre",
    plans_footer: "La création de votre dossier voyage est gratuite. Vous choisissez votre offre uniquement après validation par Diego.",
    expert_label: "Votre expert",
    expert_title: "Un vrai passionné",
    expert_title_em: "derrière chaque voyage",
    expert_quote: "« Tout a commencé les pieds nus sur les pistes africaines. J'ai grandi avec l'horizon pour seule limite. »",
    expert_desc: "Bénin, Réunion, Maroc, Madagascar — Diego a passé sa vie à explorer. Aujourd'hui, il met cette expérience au service de vos aventures.",
    expert_photo_caption: "Diego, quelque part dans l'Océan Indien",
    expert_cta: "Lire son histoire",
    footer_tos: "CGU",
    footer_privacy: "Confidentialité",
    footer_contact: "Contact",
    footer_tagline: "Voyage conçu sur mesure · Validé par un expert humain",
  },
  auth: {
    login_title: "Bon retour, voyageur",
    login_subtitle: "Vos aventures vous attendent",
    email: "Email",
    password: "Mot de passe",
    email_placeholder: "vous@exemple.fr",
    password_placeholder: "Votre mot de passe",
    login_btn: "Se connecter",
    login_loading: "Connexion en cours...",
    no_account: "Première aventure ?",
    create_account: "Créer un compte gratuit",
    error_default: "Email ou mot de passe incorrect",
    welcome_back: "Bienvenue de retour !",
    register_title: "Commencez votre odyssée",
    register_subtitle: "Gratuit pour démarrer · À partir de 29 € pour débloquer",
    name: "Prénom et nom",
    name_placeholder: "Jean Dupont",
    register_btn: "Créer mon compte gratuitement",
    register_loading: "Création du compte...",
    tos: "En vous inscrivant, vous acceptez nos conditions d'utilisation.",
    already_member: "Déjà voyageur ?",
    login_link: "Se connecter",
    welcome: "Bienvenue sur Voyage-r ! Votre aventure commence ici.",
    password_min: "Le mot de passe doit contenir au moins 6 caractères",
    error_register: "Erreur lors de l'inscription",
  },
  dashboard: {
    label: "Tableau de bord",
    title: "Mes voyages",
    greeting: "Bonjour, {name} — chaque voyage est une page nouvelle",
    new_trip: "Nouveau voyage",
    empty_title: "Prêt pour votre première aventure ?",
    empty_desc: "Votre conseiller prépare tout — itinéraire, budget, infos pratiques.",
    empty_cta: "Planifier mon premier voyage",
    error_load: "Impossible de charger vos voyages",
    delete_confirm: "Supprimer ce voyage définitivement ?",
    delete_success: "Voyage supprimé",
    delete_error: "Erreur lors de la suppression",
    see_trip: "Voir le voyage",
    since: "Depuis",
    traveler: "voyageur",
    travelers: "voyageurs",
    status_pending: "en validation",
    status_unlock: "à débloquer",
    status_unlocked: "débloqué",
    status_expired: "expiré",
    status_planned: "planifié",
  },
  plan: {
    step_label: "Étape {n} sur {total}",
    step1: "Le voyage",
    step2: "Vos envies",
    step3: "Personnalisation",
    step4: "Génération",
    step1_title: "Le voyage",
    step1_subtitle: "Votre conseiller s'occupe de tout — remplissez ce que vous savez, laissez le reste vide.",
    dep_city: "Ville de départ *",
    dep_placeholder: "Paris, Lyon, Marseille...",
    destination: "Destination",
    dest_hint: "(vide = votre conseiller suggère)",
    dest_placeholder: "Tokyo, Bali, Marrakech...",
    dep_date: "Date de départ *",
    ret_date: "Date de retour *",
    adults: "Adultes",
    children: "Enfants",
    budget: "Budget total",
    trip_type: "Type de voyage",
    next: "Continuer",
    step2_title: "Vos envies",
    step2_subtitle: "Sélectionnez ce qui vous attire — votre conseiller en tiendra compte.",
    ambiances: "Ambiances recherchées",
    accommodation: "Hébergement préféré",
    pace: "Rythme de voyage",
    gastronomy: "Gastronomie",
    transport: "Transport sur place",
    prev: "Retour",
    step3_title: "Personnalisation",
    step3_subtitle: "Plus vous nous dites, plus l'itinéraire sera parfait.",
    interests: "Centres d'intérêt",
    constraints: "Contraintes particulières",
    comfort: "Niveau de confort",
    experience: "Expérience voyage",
    documents: "Documents de voyage",
    free_text: "Ce que vous voulez absolument faire / éviter",
    free_text_placeholder: "Ex: Je veux voir le mont Fuji, mais éviter les foules touristiques...",
    generate: "Composer mon voyage",
    loading_title: "Votre voyage prend forme",
    loading_remaining: "Environ {n} secondes restantes",
    loading_finalizing: "Finalisation en cours...",
    loading_progress: "Progression",
    loading_note: "Ne fermez pas cette fenêtre — votre dossier voyage est en cours de préparation",
    gen_step1: "Analyse de vos envies",
    gen_step1_desc: "Destination, dates, ambiances, budget...",
    gen_step2: "Composition de l'itinéraire",
    gen_step2_desc: "Jour par jour, activités, rythme...",
    gen_step3: "Informations pratiques",
    gen_step3_desc: "Visa, santé, météo, sécurité...",
    gen_step4: "Budget & réservations",
    gen_step4_desc: "Estimation par poste, liens utiles...",
    gen_step5: "Finalisation par Diego",
    gen_step5_desc: "Votre expert peaufine les derniers détails...",
    error_timeout: "La génération a pris trop de temps. Veuillez réessayer.",
    error_default: "Erreur de génération. Veuillez réessayer.",
    chips: {
      ambiances: ["Plage & mer", "Montagne & nature", "Culture & musées", "Gastronomie locale", "Vie nocturne", "Randonnée", "Sports", "Shopping", "Bien-être & spa", "Aventure", "Photographie", "Rencontres locales"],
      accommodations: ["Hôtel 3★", "Hôtel 4-5★", "Airbnb", "Hostel", "Resort tout compris", "Éco-lodge", "Peu importe"],
      paces: ["Très posé", "Équilibré", "Actif", "Intense"],
      gastronomy: ["Cuisine locale", "Gastronomique", "Street food", "Végétarien", "Sans gluten", "Halal", "Peu importe"],
      transport: ["Voiture de location", "Transports en commun", "Taxi", "Moto", "Vélo", "Vols intérieurs", "Peu importe"],
      interests: ["Histoire & archéologie", "Art & architecture", "Faune & flore", "Plongée", "Surf", "Yoga & méditation", "Vignobles", "Festivals", "Parcs nationaux"],
      constraints: ["Mobilité réduite", "Allergie alimentaire", "Peur de l'avion", "Femme enceinte", "Aucune contrainte"],
      comforts: ["Économique", "Confortable", "Premium", "Luxe"],
      experiences: ["Novice", "Intermédiaire", "Expérimenté", "Grand voyageur"],
      documents: ["Passeport valide", "Passeport + visa", "Passeport à renouveler", "Aucun document"],
      budgets: ["Moins de 1 000 €", "1 000–2 000 €", "2 000–4 000 €", "4 000–8 000 €", "8 000–15 000 €", "Plus de 15 000 €"],
      trip_types: ["Vacances classiques", "Lune de miel", "Famille", "Entre amis", "Solo", "Aventure", "City trip", "Bien-être"],
    },
  },
  trip: {
    pending_label: "En cours de traitement",
    pending_title: "Diego révise votre voyage",
    pending_desc: "Votre itinéraire vers {dest} est en cours de validation par Diego. Il vérifie personnellement chaque détail avant de vous donner accès.",
    pending_what_label: "Ce que vous recevrez",
    pending_feat1: "Itinéraire personnalisé validé par un expert",
    pending_feat2: "Budget réaliste et détaillé",
    pending_feat3: "Infos pratiques indispensables",
    pending_feat4: "Conseiller voyage dédié à votre destination (offre Sérénité)",
    pending_note: "Vous recevrez une notification dès que votre voyage sera prêt.",
    expired_title: "Accès expiré",
    expired_desc: "L'accès à ce voyage vers {dest} a expiré 15 jours après votre retour. Vos souvenirs, eux, sont pour toujours.",
  },
  payment: {
    ready_label: "Votre voyage est prêt",
    validated_title: "Diego a validé votre itinéraire",
    validated_desc: "Choisissez votre offre pour débloquer votre voyage vers {dest}.",
    per_trip: "par voyage",
    popular: "Le plus populaire",
    unlock_btn: "Débloquer avec l'offre {name} — {price} €",
    unlocking: "Redirection vers le paiement...",
    secure: "Paiement sécurisé par Stripe · Accès immédiat après confirmation",
    error: "Erreur lors de l'initiation du paiement",
    terms_checkbox_pre: "J'ai lu et j'accepte les",
    terms_link: "Conditions Générales de Vente",
    terms_checkbox_post: "— Je comprends que Voyage-r est un service de conseil, non une agence de voyage, et ne gère pas mes réservations.",
    terms_required: "Veuillez accepter les Conditions Générales de Vente avant de continuer.",
  },
  push: {
    enable_btn: "Activer les notifications",
    disable_btn: "Désactiver les notifications",
    enabled_toast: "Notifications activées — vous serez alerté dès que Diego valide votre voyage.",
    disabled_toast: "Notifications désactivées.",
    denied_toast: "Notifications bloquées par le navigateur. Autorisez-les dans les paramètres.",
  },
};

export default fr;
